import { html, nothing, type TemplateResult } from "lit";

export interface BookingDetailsViewModel {
  firstNameField: TemplateResult;
  lastNameField: TemplateResult;
  emailField: TemplateResult;
  phoneField: TemplateResult;
  /**
   * Date of birth / emergency contact, when the ORG requires them
   * (PLAT-4456). `nothing` for a signed-in member or an org with no policy.
   */
  requiredProfileFields: TemplateResult | typeof nothing;
  recipientSection: TemplateResult | typeof nothing;
  waiver: TemplateResult | typeof nothing;
  intakeForms: TemplateResult | typeof nothing;
  errors: TemplateResult | typeof nothing;
  nextAction: TemplateResult;
}

export function renderBookingDetails(
  model: BookingDetailsViewModel,
): TemplateResult {
  return html`
    <div class="grid2">${model.firstNameField} ${model.lastNameField}</div>
    <div class="grid2">${model.emailField} ${model.phoneField}</div>
    ${model.requiredProfileFields} ${model.recipientSection} ${model.waiver}
    ${model.intakeForms} ${model.errors} ${model.nextAction}
  `;
}

export interface AttendeeFieldsViewModel {
  heading: string;
  removable: boolean;
  firstNameField: TemplateResult;
  lastNameField: TemplateResult;
  dateOfBirthField: TemplateResult | typeof nothing;
  emailField: TemplateResult;
  phoneField: TemplateResult;
  /**
   * The required questions from this attendee's own waiver/intake forms.
   * `nothing` when their forms ask nothing the contact fields above don't
   * already answer.
   */
  formFields: TemplateResult | typeof nothing;
  waiver: TemplateResult | typeof nothing;
  help: string;
  onRemove: () => void;
}

export function renderAttendeeFields(
  model: AttendeeFieldsViewModel,
): TemplateResult {
  return html`
    <div class="person person-add">
      <div class="ph">
        <h5>${model.heading}</h5>
        ${model.removable
          ? html`<button class="rm" @click=${model.onRemove}>Remove</button>`
          : nothing}
      </div>
      <div class="grid2">${model.firstNameField} ${model.lastNameField}</div>
      ${model.dateOfBirthField}
      <div class="grid2">${model.emailField} ${model.phoneField}</div>
      ${model.formFields} ${model.waiver}
      <div class="help">${model.help}</div>
    </div>
  `;
}
